import { render, staticRenderFns } from "./ChildAvatar.vue?vue&type=template&id=3a25d372&scoped=true&lang=pug"
import script from "./ChildAvatar.vue?vue&type=script&lang=js"
export * from "./ChildAvatar.vue?vue&type=script&lang=js"
import style0 from "./ChildAvatar.vue?vue&type=style&index=0&id=3a25d372&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a25d372",
  null
  
)

export default component.exports